<template>
  <div>
    <training-toolbar v-if="userInfo"/>
    <div class="card mx-md-5 mt-3 mb-3 bg-form">
      <card-header v-if="userInfo"
        :title="$t('parametrics.modulesTitle')"
        :iconName="'folder-check'"
      />
      <b-card-body>
        <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>
        <b-alert v-for="error in errors" :key="error.message" v-model="popAlert"  variant="danger" dismissible>
          {{ error.message }}
        </b-alert>

        <template>
          <modules-tabs v-on:error:api.capture="handleError"/>
        </template>
      </b-card-body>
    </div>
  </div>
</template>

<script>
import CardHeader from '../../components/common/cardHeader.vue'
import trainingService from '../../services/training.service';
import { handleApiError } from '../../services/error.service';
import TrainingToolbar from '../../components/common/trainingToolbar.vue';
import ModulesTabs from '../../components/parametrics/modulesTabs.vue';
import {hasRole} from "esep/src/services/utils";
import {roles, routes} from "esep/src/services/routing.service";


export default {
  components: {
    CardHeader,
    TrainingToolbar,
    ModulesTabs
  },
  mounted() {
    trainingService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;
        if (!hasRole(this.userInfo,roles.training.parametrics)){
          location.replace(routes.nothing);
        }
        this.$store.state.userInfo = this.userInfo;
        this.fetchRoles();
      },
      (error) => {
        let errorMessage = handleApiError(error);
        this.handleError(errorMessage);
      }
    );
  },
  data() {
    return {
      userInfo: null,
      popSuccessAlert: false,
      popAlert: false,
      successMessage: null,
      errors: null,
      isAdmin: false,
      isTrainingAdmin: false,
      isTrainingMod: false
    }
  }, 
  methods: {
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
    },
    fetchRoles() {
      for(var i=0; i< this.userInfo.roles.length; i++){
        if(this.userInfo.roles[i].name == "ADMIN" ) {
          this.isAdmin = true;
        } else if(this.userInfo.roles[i].name == "TRAINING_ADMIN") {
          this.isTrainingAdmin = true;
        } else if(this.userInfo.roles[i].name == "TRAINING_MOD"){
          this.isTrainingMod = true;
        }
      }
    }
  }
}
</script>